











export default {
  name: 'SfOverlay',
  props: {
    transition: {
      type: String,
      default: 'sf-fade',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
